import type { IOrthOProcedureCustomControlData } from '../../../../../common/interfaces/ophthalmology/orthO/orthOProcedureCustomControlData';
import type { ValidationErrors } from '../../../../utils/validation';
import type { IOrthOV1ProcedureProps } from './OrthOV1ProcedureRead';
import { HeaderDivider } from '../../../elements/common';
import { OrthOV1ProcedureAdditionalExaminations } from './OrthOV1ProcedureAdditionalExaminations';
import { OrthOV1ProcedureBinocularFunctions } from './OrthOV1ProcedureBinocularFunctions';
import { OrthOV1ProcedureOcularAlignment } from './OrthOV1ProcedureOcularAlignment';
import { OrthOV1ProcedureOcularMotility } from './OrthOV1ProcedureOcularMotility';
import { OrthOV1ProcedureVision } from './OrthOV1ProcedureVision';

export type IOrthOV1ProcedureExaminationsProps =
    | IOrthoV1ProcedureExaminationsAddEditProps
    | IOrthoV1ProcedureExaminationsReadProps;

export interface IOrthoV1ProcedureExaminationsAddEditProps extends IOrthOV1ProcedureProps {
    errors: ValidationErrors;
    handleChangeCustomControl: <T = IOrthOProcedureCustomControlData>(values: Partial<T>) => Promise<void>;
    isOrthOFol?: boolean;
    isReadOnly: false;
    validateOneCustomControl: (name: string, index?: number) => void;
}
export interface IOrthoV1ProcedureExaminationsReadProps extends IOrthOV1ProcedureProps {
    isReadOnly: true;
}

export function OrthOV1ProcedureExaminations(props: IOrthOV1ProcedureExaminationsProps) {
    return (
        <>
            <HeaderDivider text="Onderzoek" />

            <OrthOV1ProcedureOcularAlignment {...props} />
            <OrthOV1ProcedureBinocularFunctions {...props} />
            <OrthOV1ProcedureOcularMotility {...props} />
            <OrthOV1ProcedureVision {...props} />
            <OrthOV1ProcedureAdditionalExaminations {...props} />
        </>
    );
}
